import React, { useRef, useState, useEffect } from "react";
import { TableRow, TableCell, Button, Tooltip, Typography } from "@mui/material";
import CustomCheckbox from "../CustomCheckbox";

const cellStyle = {
  padding: "10px 16px",
};

const BillingHistoryTableRow = ({ row, isSelected, onSelectToggle }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      setIsTruncated(textRef.current.scrollHeight > textRef.current.clientHeight + 1);
    }
  }, [row.description2]);

  const descriptionContent = (
    <Typography
      ref={textRef}
      sx={{
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
        cursor: isTruncated ? "pointer" : "default",
        fontSize: "13px",
      }}
    >
      {row.description2}
    </Typography>
  );

  return (
    <TableRow
      sx={{
        '&:hover': { boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)' },
        backgroundColor: '#fff',
        borderRadius: '10px',
        transition: 'box-shadow 0.3s ease',
      }}
    >
      <TableCell sx={{ ...cellStyle, border: "none", minWidth: "32px", maxWidth: "32px" }}>
        <CustomCheckbox checked={isSelected} onChange={onSelectToggle} />
      </TableCell>
      <TableCell sx={{ ...cellStyle, border: "none" }}>{row.id}</TableCell>
      <TableCell sx={{ ...cellStyle, border: "none", textAlign: "center", color: "#595959" }}>
        {row.createdOn}
      </TableCell>
      <TableCell sx={{ ...cellStyle, border: "none", textAlign: "center", color: "#1760EC" }}>
        {row.invoiceNumber}
      </TableCell>
      <TableCell sx={{ ...cellStyle, border: "none", color: "#595959", maxWidth: 200 }}>
        {isTruncated ? (
          <Tooltip title={row.description2} arrow>
            {descriptionContent}
          </Tooltip>
        ) : (
          descriptionContent
        )}
      </TableCell>
      <TableCell sx={{ ...cellStyle, border: "none", textAlign: "center", color: "#1760EC" }}>
        {row.transaction}
      </TableCell>
      <TableCell sx={{ ...cellStyle, border: "none", textAlign: "center" }}>
        <Button
          sx={{
            background: row.status === "Paid" ? "rgba(0, 194, 52, 0.08)" : "rgba(243, 156, 18, 0.05)",
            color: row.status === "Paid" ? "#00C234" : "#F39C12",
            border: "none",
            fontSize: "13px",
            textTransform: "capitalize",
            borderRadius: "40px",
            px: 3,
          }}
        >
          {row.status}
        </Button>
      </TableCell>
      <TableCell sx={{ ...cellStyle, border: "none", textAlign: "center", color: "#1760EC" }}>
        {row.amount}
      </TableCell>
    </TableRow>
  );
};

export default BillingHistoryTableRow;
